module.exports = __webpack_public_path__ + "media/images/video-square-grey-2ad79f48.svg";